import Footer from "./components/Footer";
import Header from "./components/Header";
import PageWrapper from "./pages/wrapper";

function App() {
  return (
    <div className="h-full h-screen w-full">
      <Header/>
      <PageWrapper/>
      <Footer/>
    </div>
  );
}

export default App;
